import { render } from "./_select.vue?vue&type=template&id=457bf4f0&scoped=true"
import script from "./_select.vue?vue&type=script&lang=js"
export * from "./_select.vue?vue&type=script&lang=js"

import "./_select.vue?vue&type=style&index=0&id=457bf4f0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457bf4f0"]])

export default __exports__